import { CompleteStoreFragment } from 'drycut-graphql';
import { PropsWithChildren } from 'react';
import { Heading, MobileNavbar, PromotionBadge, Stack } from 'ui-components';
import { PassBubble } from '../PassBubble';

type Props = PropsWithChildren<{
  onSubmit?: (data: never) => void;
  store: CompleteStoreFragment;
}>;

export default function StepContainer({ onSubmit, store, children }: Props): React.ReactElement {
  return (
    <form onSubmit={onSubmit} className="flex flex-col h-full" noValidate>
      <MobileNavbar title={`DRYCUT ${store.name}`} />

      <Stack gap={7} className="relative items-center text-center h-full">
        <PromotionBadge store={store} className="-top-16 -left-10 lg:-top-20 lg:-left-32" />

        <PassBubble storeSlug={store.slug} className="-right-8 lg:-right-28" />

        <Stack className="hidden lg:block">
          <Heading variant="h2">DRYCUT</Heading>
          <Heading variant="h2">{store.name}</Heading>
        </Stack>

        {children}
      </Stack>
    </form>
  );
}
